// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"loader_loader_wrapper__G+7MW"};